import styled, { css } from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { MOBILE_BREAKPOINT, purpleMui } from "@ryde/theme";

export const TemplateWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "form-template-wrapper",
})<{ $leftOffsetLevel?: number; $customContainerTopMargin?: number | string }>`
  width: 100%;
  margin: 21px 0 0 0;
  margin-top: ${({ $customContainerTopMargin }) =>
    $customContainerTopMargin !== undefined && $customContainerTopMargin};
  ${({ $leftOffsetLevel }) =>
    $leftOffsetLevel &&
    css`
      padding-inline-start: 10px;
      border-inline-start: 1px dashed ${purpleMui._700};
    `}

  &.template-wrapper-blur:not(:has(.no-blur-item)) {
    filter: blur(2px) grayscale(100%);
    backdrop-filter: blur(3px);
  }

  &.template-wrapper-blur {
    transition:
      filter 0.55s ease-out,
      backdrop-filter 0.55s ease-out;
  }

  &.template-wrapper-blur:has(.no-blur-item) {
    filter: none !important;
    backdrop-filter: none !important;
  }

  &.template-wrapper-blur:has(.no-blur-item) * {
    filter: none !important;
    backdrop-filter: none !important;
  }
`;
export const FullWidthTextFieldWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "full-width-wrapper",
})`
  position: relative;
  width: 100%;
  overflow: visible;

  .MuiFormControl-root {
    width: 100%;
  }
`;

export const FieldsWrapper = styled.div.attrs<IStyledAttributes>({
  [DATA_E2E_KEY]: "fields-wrapper",
})`
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: stretch;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    padding-inline-start: 10px;
    padding-inline-end: 10px;
  }
`;
